
import {
  Component, Prop, Mixins,
} from 'vue-property-decorator';
import CostStatistics from '@/features/dashboard/components/widgets/costBreakdown/CostStatistics.vue';
import CouriersStatistics from '@/features/dashboard/components/widgets/costBreakdown/CouriersStatistics.vue';
import NoContent from '@/features/dashboard/components/widgets/NoContent.vue';
import DataTypeSwitch from '@/features/dashboard/components/widgets/costBreakdown/DataTypeSwitch.vue';
import { PeriodItemType } from '@/features/common/raw';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component({
  components: {
    CostStatistics,
    CouriersStatistics,
    DataTypeSwitch,
    NoContent,
  },
})
export default class Content extends Mixins(ResponsivenessMixin) {
  @Prop({ default: true }) isEmpty!: boolean;

  @Prop({ required: true }) currentType!: string;

  @Prop({ required: true }) periodItems!: PeriodItemType[];
}
